/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: CustomIconImg.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  16.08.23 5:16 pm.
 * Last modified: 16.08.23 5:16 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';

const CustomIconImg = ({ name, host }: { name: string; host: string }) => {
    return (
        <img
            src={addBuildHash(`${host}/assets/portal/icons/${name.toLowerCase()}_icon.svg`)}
            alt={name}
            className="tab"
        />
    );
};

export default CustomIconImg;
